<span style="font-size: 20px;color: rgba(0, 0, 0, 0.87);vertical-align: middle;">
    <!-- {{user.Username}} -->
</span>
<button color="primary" mat-icon-button [mat-menu-trigger-for]="menu">
    <mat-icon color="primary">more_vert</mat-icon>
</button>
<mat-menu x-position="before" #menu="matMenu">
    <button color="primary" mat-menu-item (click)="logout()">
        <mat-icon color="primary">exit_to_app</mat-icon>Ausloggen</button>
    <button *ngIf="router.url != '/vertrag/impressum'" color="primary" mat-menu-item [routerLink]="['/vertrag/impressum']">
        <mat-icon color="primary">info</mat-icon>Impressum</button>
    <button *ngIf="router.url == '/vertrag/impressum'" color="primary" mat-menu-item [routerLink]="['/vertrag']">
        <mat-icon color="primary">reply</mat-icon>Zur Liste</button>
</mat-menu>


// WEBPACK FOOTER //
// ./src/app/_authentication/logout/logout.component.html